module.exports = __webpack_public_path__ + "img/card3.64dc402d.jpg";